export const basicInfo = {
  title: '',
  description: '',
  internalNotes: '',
  finishTime: '',
  thumbnail: ''
};


// WEBPACK FOOTER //
// ./src/data/EditChapterPart/BasicInfo.js